import { FormikProps } from 'formik';
import { ToastStateHandler, UserApi } from '../../../api';
import { PatchGoogleIntegration } from '../../../commonTypes/user.types';
import { useContainer } from '../../useContainer';
import { useNavigate } from 'react-router';
import { IGoogleCalendarValues } from '../../../views/GoogleIntegrationPage';
import { useTranslation } from '../../useTranslation';

const useHttpPatchGoogleIntegration = (context: FormikProps<IGoogleCalendarValues>) => {
    const { t } = useTranslation('newNotifications');
    const userApi: UserApi = useContainer(UserApi);
    const navigate = useNavigate();
    const toastHandler = useContainer(ToastStateHandler);

    const exec = (body: PatchGoogleIntegration) => {
        const { exec, abort } = userApi.updateGoogleIntegration({
            body,
            onSuccess: () => {
                toastHandler.push('success', t('googleIntegration.settingsTitle'), t('googleIntegration.updateSuccess'));
                context.initialValues.gmailAutoReplySubject = context.values.gmailAutoReplySubject;
                context.initialValues.gmailAutoReplyText = context.values.gmailAutoReplyText;
                navigate('/integrations/google');
            },
            onError: () => toastHandler.push('error', t('googleIntegration.settingsTitle'), t('googleIntegration.updateFailed')),
        });
        exec();
        return abort;
    };

    return { exec };
};

export default useHttpPatchGoogleIntegration;
